/**
 * Tabs theme
 * @see https://github.com/chakra-ui/chakra-ui/blob/v2/packages/theme/src/components/tabs.ts
 */
import { tabsAnatomy as parts } from '@chakra-ui/anatomy';
import { brand, gradients } from '../colors';
import { textStyles } from '../textStyles';
export const Tabs = {
    parts: parts.keys,
    baseStyle() {
        return {};
    },
    variants: {
        line: (props) => {
            const { orientation } = props;
            const isVertical = orientation === 'vertical';
            const borderProp = isVertical ? 'borderStart' : 'borderBottom';
            const selectedBg = `${gradients['blue-border-vertical']} bottom left / 95% 1px no-repeat`;
            return {
                tablist: {
                    [borderProp]: 'none',
                },
                tab: {
                    textTransform: 'capitalize',
                    [borderProp]: 'none',
                    _hover: {
                        background: 'radial-gradient(ellipse 60% 100% at center, #12CFF430 0%, transparent 70%)',
                        _selected: {
                            background: selectedBg,
                        },
                        _disabled: {
                            background: 'initial',
                        },
                    },
                    _selected: {
                        color: brand['secondary-sky-blue'],
                        fontWeight: '700',
                        background: `${gradients['blue-border-vertical']} bottom left / 95% 1px no-repeat`,
                    },
                },
            };
        },
        solid: () => {
            return {
                tablist: {
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: 'brand.gray-scale-border-10',
                    bg: 'gradients.dark-blue',
                    rounded: '10px',
                    p: '2px',
                    gap: '4px',
                },
                tab: {
                    textTransform: 'capitalize',
                    rounded: '8px',
                    _selected: {
                        bg: 'gradients.blue-green-horizontal',
                        color: 'brand.secondary-dark-blue',
                        fontWeight: '700',
                    },
                },
            };
        },
    },
    sizes: {
        sm: {
            tab: {
                ...textStyles.body1,
                py: '8px',
            },
        },
        md: {
            tab: {
                ...textStyles.body1,
                py: '16px',
            },
        },
    },
    defaultProps: {},
};
